// extracted by mini-css-extract-plugin
module.exports = {"table":"CategoriesContractsTable_table__21Iym","logoSubSupplier":"CategoriesContractsTable_logoSubSupplier__2Fi0N"};